import {
	LIST_COLLECTION_LIST_ADD,
	LIST_COLLECTION_LIST_SET,
	LIST_COLLECTION_LIST_FINISHED,
	LIST_COLLECTION_LIST_SKIP,
	LIST_COLLECTION_LIST_LOADING,
	LIST_COLLECTION_FILTER_SET,
	LIST_COLLECTION_SORTERS_SET,
	LIST_COLLECTION_MESSAGE_CONFIG,
	LIST_COLLECTION_FILTER_DATA
} from '../../actions/pages/list-collections'

const initialState = {
	list: [],
	collection: null,
	filterVo: null,
	sorters: [],
	skip: 0,
	finished: false,
	loading: false,
	messageConfig: null,
	filterData: null
}

export default (state = initialState, action) => {
	switch (action.type){
		case LIST_COLLECTION_MESSAGE_CONFIG:
			return {...state, messageConfig: action.payload}
		case LIST_COLLECTION_LIST_SET:
			return {...state, list: action.payload}
		case LIST_COLLECTION_LIST_ADD:
			return {...state, list: [...(state.list||[]), ...(action.payload||[])]}
		case LIST_COLLECTION_LIST_SKIP:
			return {...state, skip: action.payload}
		case LIST_COLLECTION_LIST_FINISHED:
			return {...state, finished: action.payload}
		case LIST_COLLECTION_LIST_LOADING:
			return {...state, loading: action.payload}
		case LIST_COLLECTION_FILTER_SET:
			return {...state, filterVo: action.payload}
		case LIST_COLLECTION_SORTERS_SET:
			return {...state, sorters: action.payload}
		case LIST_COLLECTION_FILTER_DATA:
			return {...state, filterData: action.payload}	
		default:
			return state
	}
}